// extracted by mini-css-extract-plugin
export default {"modalWrapper":"WarningModal_modalWrapper__Y0XQc","content":"WarningModal_content__H6VDi","footer":"WarningModal_footer__hHblt"};